import type { AgreementQuerySchema } from '../schemas';

export const fieldNames: Record<keyof AgreementQuerySchema, { name: string; revertible: boolean }> = {
  pipeline: { name: 'Pipeline', revertible: true },
  agreement_date: { name: 'Agreement Date', revertible: true },
  expiry_date: { name: 'Expiration Date', revertible: true },
  client_id: { name: 'Company ID', revertible: false },
  client: { name: 'Company', revertible: false },
  status: { name: 'Status', revertible: true },
  primary_domains: { name: 'Domains', revertible: true },
  purchase_order: { name: 'Purchase Order', revertible: true },
  billing_term: { name: 'Billing Term', revertible: true },
  terms_condition_template: { name: 'Terms Template', revertible: true },
  brand: { name: 'Brand', revertible: true },
  partner: { name: 'Partner', revertible: true },
  account_manager: { name: 'Account Manager', revertible: true },

  agreement_contact: { name: 'Agreement Contact', revertible: true },
  project_contact: { name: 'Project Contact', revertible: true },
  billing_contact: { name: 'Billing Contact', revertible: true },
  emergency_contact: { name: 'Emergency Contact', revertible: true },
  billing_email_contacts: { name: 'Additional Billing Email Notifications', revertible: true },

  id: { name: 'ID', revertible: false },
  agreement_deliverables: { name: 'ID', revertible: false },
  agreement_id: { name: 'Agreement ID', revertible: false },
  opt_in: { name: 'Opt In', revertible: false },
  one_time_total: { name: 'One Time Total', revertible: false },
  opt_in_total: { name: 'Opt In Total', revertible: false },
  monthly_recurring_total: { name: 'Recurring', revertible: false },
  annual_recurring_total: { name: 'Annual Recurring', revertible: false },
  billing_term_id: { name: 'Billing Term ID', revertible: false },
  terms_condition_template_id: { name: 'Terms Template', revertible: false },
  brand_id: { name: 'Brand', revertible: false },
  partner_id: { name: 'Partner', revertible: false },
  harvest: { name: 'Harvest ID', revertible: true },

  agreement_draft: { name: 'Agreement Draft', revertible: false },
  fully_executed_agreement: { name: 'Full Executed Agreement', revertible: false },

  execution_date: { name: 'Execution Date', revertible: true },
  implementation_start_date: { name: 'Implementation Start Date', revertible: true },
  go_live_date: { name: 'Go Live Date', revertible: true },
  monthly_recurring_start_date: { name: 'Recurring Billing Start Date', revertible: true },
  monthly_recurring_stop_date: { name: 'Recurring Stop Date', revertible: true },
  annual_recurring_start_date: { name: 'Annual Recurring Billing Start Date', revertible: true },
  annual_recurring_stop_date: { name: 'Annual Recurring Stop Date', revertible: true },

  agreement_signer: { name: 'Agreement Signer', revertible: false },
  agreement_signer_id: { name: 'Agreement Signer ID', revertible: false },

  agreement_installments: { name: 'Installments', revertible: false },
  wholesale_price_enabled: { name: 'Wholesale Price', revertible: true },
  selectedWholesaleDateRange: { name: 'Wholesale Date Range', revertible: false },
  addresses: { name: 'Addresses', revertible: false },

  parent: { name: 'Parent', revertible: false },
  parent_id: { name: 'Parent ID', revertible: false },
  addendums: { name: 'Addendums', revertible: false },

  exclude_from_averages: { name: 'Exclude from Averages', revertible: true },

  agreement_commissions: { name: 'Agreement Commissions', revertible: false },
  enable_commission: { name: 'Enable Commissions', revertible: true },
  activate_subsidy_billing: { name: 'Activate Subsidy Billing', revertible: true },
  subsidies: { name: 'Subsidies', revertible: false },
  delay_allocating_revenue: { name: 'Delay Allocating Revenue', revertible: true },
  hide_taxable_column_from_invoices: { name: 'Hide Taxable Column from Invoices', revertible: true },
  // subsidy_clients: { name: 'Subsidy Clients', revertible: false },
  // primary_contact: { name: 'Primary Contact', revertible: false },
  // subsidy_billing: { name: 'Subsidy Billing', revertible: true },
  contracting_party: { name: 'Contracting Party', revertible: false },

  orphan_invoicing: { name: 'Orphan Invoicing', revertible: true },
};
